import {
  SearchContainer,
  SearchIcon,
  SearchInput,
  SearchIconContainer,
} from "./search.styles";
import { useTranslation } from "react-i18next";

type SearchProps = {
  show: boolean;
  color?: string;
  containerStyles?: React.CSSProperties;
} & React.InputHTMLAttributes<HTMLInputElement>;
const Search = ({
  color = "#C4C4C4",
  containerStyles,
  ...otherProps
}: SearchProps) => {
  const { t } = useTranslation();
  return (
    <SearchContainer
      style={{ border: `1px solid ${color}`, ...containerStyles }}
    >
      <SearchInput
        type="search"
        placeholder={t("adminDashboard__searchPlaceholder")}
        {...otherProps}
        className="!rounded-full"
      />
      <SearchIconContainer className="bg-[#c4c4c4]">
        <SearchIcon />
      </SearchIconContainer>
    </SearchContainer>
  );
};
export default Search;
